import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { MapHelperService } from 'src/services/map-helper.service';

@Component({
  selector: 'zone-location-searcher',
  templateUrl: './zone-location-searcher.component.html',
  styleUrls: ['./zone-location-searcher.component.css']
})
export class ZoneLocationSearcherComponent {

  @Input() locationHash: Map<string, { lng: number, lat: number }> = new Map();
  @Input() locationIdentifier: string = '';
  @Input() isSearchDisabled: boolean = false;

  @Output() searchLocationChange = new EventEmitter<string>();
  @Output() dropdownVisibilityChange = new EventEmitter<boolean>();

  inputFocused: boolean = false;
  showSuggestions: boolean = false;

  locationSuggestions: { identifier: string, lng: number, lat: number }[] = [];
  private searchSubject = new Subject<string>();

  constructor(private mapHelperService: MapHelperService) {
    this.searchSubject.pipe( debounceTime(500), distinctUntilChanged()).subscribe(searchTerm => {
          console.log("debounce", searchTerm);
          
          this.locationIdentifier = searchTerm;
          this.searchLocationChange.emit(this.locationIdentifier);
          this.runSearch();
        });
   }

  ngOnInit(): void {
    this.suggestFirstLocations();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['locationHash']) {
      this.locationIdentifier = '';
      this.locationSuggestions = [];
      this.showSuggestions = false;
      this.searchLocationChange.emit(this.locationIdentifier);
      this.suggestFirstLocations();
    }
  }

  ngOnDestroy(): void {
    this.searchSubject.complete();
  }

  suggestFirstLocations(){
    if(this.locationHash.size > 0){
      for(let [identifier, coords] of this.locationHash.entries()){

        this.locationSuggestions.push({ identifier, lng: coords.lng, lat: coords.lat });
        
        if(this.locationSuggestions.length >= 5){
          break;
        }
      }
    }
  }

  onSearchInput(){
    this.searchSubject.next(this.locationIdentifier);
  }

  runSearch() {
    if (this.locationIdentifier) {
      const suggestions = [];
      const searchLower = this.locationIdentifier.toLowerCase();
      for (let [identifier, coords] of this.locationHash.entries()) {
        if (identifier.toLowerCase().includes(searchLower)) {
          suggestions.push({ identifier, lng: coords.lng, lat: coords.lat });

          if (suggestions.length >= 5) {
            break;
          }
        }
      }
      this.locationSuggestions = suggestions;
      this.showSuggestions = suggestions.length > 0;
    } else {
      this.locationSuggestions = [];
      this.showSuggestions = false;
      this.suggestFirstLocations();
    }
    this.updateDropdownVisibility();
  }

  searchLocation(){
    if (!this.locationIdentifier) {
      this.locationSuggestions = [];
      this.showSuggestions = false;
      return;
    }
  }

  onInputFocus(): void {
    this.inputFocused = true;
    this.updateDropdownVisibility();
  }

  onInputNoFocus(): void {
    setTimeout(() => {
      this.inputFocused = false;
      this.showSuggestions = false;
      this.updateDropdownVisibility();
    }, 200);
  }

  private updateDropdownVisibility(): void {
    const isVisible = this.showSuggestions && this.inputFocused && this.locationSuggestions.length > 0;
    this.dropdownVisibilityChange.emit(isVisible);
  }

  selectSuggestion(suggestion: { identifier: string, lng: number, lat: number }): void {
    this.locationIdentifier = suggestion.identifier;
    this.searchLocationChange.emit(this.locationIdentifier);
    this.showSuggestions = false;
    this.updateDropdownVisibility();

    this.mapHelperService.FlyToCameraFast(suggestion.lat.toString(), suggestion.lng.toString(), "15", 0);
  }
}
